let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aShRu")).then(() => parcelRequire('8oyn7'));